import React from "react";

const ConsumerViewShimmer = ({ size = 12 }) => {
    return (

        <div className="consumer-view-shimmer">
                <div className="shimmer user-shimmer">
                    <div className="wrappercard">
                        <div className="image-card animate"></div>
                        <div className="shimmercontant">
                            <div className="stroke animate title1"></div>
                            <div className="stroke animate title2"></div>
                            <div className="stroke animate title3"></div>
                        </div>
                    </div>
                </div>
                <div className="tab-shimmer-wrap">
                    <ul>
                        <li><div className="stroke animate title1"></div> </li>
                        <li><div className="stroke animate title1"></div> </li>
                        <li><div className="stroke animate title1"></div> </li>
                        <li><div className="stroke animate title1"></div> </li>
                        <li><div className="stroke animate title1"></div> </li>
                        <li><div className="stroke animate title1"></div> </li>
                        <li><div className="stroke animate title1"></div> </li>
                    </ul>
                </div>
                <div className="row">
                    {new Array(size).fill({}).map((a, index) => (
                        <div className="col-md-3">
                            <div className="shimmer product-shimmer consumer-card-wrap">
                                <div className="wrappercard">
                                    <div className="image-card animate"></div>
                                    <div className="shimmercontant">
                                        <div className="stroke animate title1"></div>
                                        <div className="stroke animate title2"></div>
                                        <div className="stroke animate title3"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
      
    )
}

export default ConsumerViewShimmer;